import { library } from "@fortawesome/fontawesome-svg-core"
import { far } from "@fortawesome/pro-regular-svg-icons"

// Add all FontAwesome icons to the library
library.add(far)

export const getFontAwesomeIcons = () => {
  const iconNames = Object.keys(library.definitions.far)
  
  return iconNames.map((name) => ({ name:`${name}`, icon: `fa-${name}` }))
}

export const filterIcons = (icons, searchTerm) => {
  return icons.filter((icon) => icon.name.toLowerCase().includes(searchTerm.toLowerCase()))
}
